module.exports = __webpack_public_path__ + "static/media/wof_chant.4af6b7ba.mp3";